import { useEffect, useState } from "react";
import { makeGet } from "@culturehq/client";

const useStoryAutocomplete = (onResults, page = 1) => {
  const [search, onSearch] = useState(null);

  useEffect(
    () => {
      let cancelled = false;

      // This is the initial state
      if (search === null) {
        return undefined;
      }

      // The user has searched and then removed the search
      if (!search) {
        onResults({ stories: [], pagination: {}, query: "" });
        return undefined;
      }

      // There is a valid search
      makeGet("/autocomplete/stories", { page, query: search })
        .then(({ stories, pagination }) => {
          if (!cancelled) {
            onResults({ stories, pagination, query: search });
          }
        })
        .catch(() => {
          if (!cancelled) {
            onResults({ stories: [], pagination: {}, query: search });
          }
        });

      return () => {
        cancelled = true;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, search]
  );

  return onSearch;
};

export default useStoryAutocomplete;
